export enum SessionDetailView {
  EMBEDDED = 'embedded',
  TEXTING = 'texting',
  COACHING = 'coaching',
  MAIN = 'main',
  MINIMAL = 'minimal',
  ANALYSIS = 'analysis',
}

export function viewCanSeeHeader(view: SessionDetailView) {
  return ![SessionDetailView.EMBEDDED].includes(view)
}

export function viewCanSeeComments(view: SessionDetailView) {
  return view === SessionDetailView.MAIN
}

export function viewCanSeeAllAutomations(view: SessionDetailView) {
  return [SessionDetailView.MAIN, SessionDetailView.MINIMAL].includes(view)
}

export function viewCanSeePastCalls(view: SessionDetailView) {
    return view === SessionDetailView.MAIN
}

export function viewHasMinimalHeader(view: SessionDetailView) {
  return [SessionDetailView.COACHING, SessionDetailView.EMBEDDED].includes(view)
}

export function viewEnforcesStart(view: SessionDetailView) {
  return ![SessionDetailView.COACHING, SessionDetailView.EMBEDDED, SessionDetailView.MAIN].includes(view)
}

export function viewCanSeeQuickSelects(view: SessionDetailView) {
  return [SessionDetailView.MAIN, SessionDetailView.ANALYSIS].includes(view)
}

export function viewSupportsSearch(view: SessionDetailView) {
  return [SessionDetailView.MAIN, SessionDetailView.COACHING, SessionDetailView.ANALYSIS].includes(view)
}

export function viewSupportsFilter(view: SessionDetailView) {
  return [SessionDetailView.MAIN, SessionDetailView.ANALYSIS].includes(view)
} 

export function viewRequiresHeader(view: SessionDetailView) {
  return ![SessionDetailView.EMBEDDED, SessionDetailView.TEXTING].includes(view)
}

export function viewSupportsMultiCallView(view: SessionDetailView) {
  return ![SessionDetailView.MINIMAL, SessionDetailView.ANALYSIS, SessionDetailView.COACHING].includes(view)
}

export function viewSupportsSwitch(view: SessionDetailView) {
  return ![SessionDetailView.EMBEDDED, SessionDetailView.MINIMAL].includes(view)
}

export function viewSupportsSessionSelect(view: SessionDetailView) {
  return [SessionDetailView.ANALYSIS].includes(view)
}

export function viewSupportsNavigation(view: SessionDetailView) {
  return [SessionDetailView.MAIN].includes(view)
}

export function viewSupportsInfiniteScroll(view: SessionDetailView) {
  return [SessionDetailView.MAIN].includes(view)
}

export function viewSupportsTexting(view: SessionDetailView) {
  return [SessionDetailView.TEXTING, SessionDetailView.MAIN].includes(view)
}

export function viewSupportsCustomScores(view: SessionDetailView) {
  return [SessionDetailView.MAIN, SessionDetailView.ANALYSIS].includes(view)
}

export enum SessionHistoryTabs {
  CALLS = 'calls',
  CALLBACKS = 'callbacks',
  TEXTS = 'texts',
  ALL_HISTORY = 'all_history',
  MISSED = 'missed',
}
